export default __webpack_public_path__ + "static/media/sb.9edb7101.webp";